<template>
  <el-dialog
    v-if="visible"
    append-to-body
    :title="$t('73075111')"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form" label-width="200px">
      <!-- 时间类型 -->
      <el-form-item :label="$t('f07baeba')" required>
        <el-radio-group v-model="form.date_type" :key="12" @change="changeType">
          <el-radio :label="1">{{ $t('77') }}</el-radio>
          <el-radio :label="2">{{ $t('1408') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 提交时间 -->
      <el-form-item v-if="form.date_type === 1" :label="$t('77')" required>
        <el-date-picker
          v-model="createDate"
          :defaultTime="[]"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          unlink-panels
          :start-placeholder="$t('407')"
          :end-placeholder="$t('408')"
          align="center"
          @change="val => ([form.create_date_start, form.create_date_end] = val || ['', ''])"
        >
        </el-date-picker>
      </el-form-item>
      <!-- 实际时间 -->
      <el-form-item v-if="form.date_type === 2" :label="$t('15475_9e04e26e')" required>
        <el-date-picker
          v-model="finishDate"
          :defaultTime="[]"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          unlink-panels
          :start-placeholder="$t('407')"
          :end-placeholder="$t('408')"
          align="center"
          @change="val => ([form.finish_date_start, form.finish_date_end] = val || ['', ''])"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('74')" :required="form.date_type === 2">
        <el-select
          v-if="upDate"
          v-model="form.audit_type"
          :placeholder="$t('74')"
          value-key="label"
          :multiple="isMultiple"
        >
          <el-option v-for="item in typeArr" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <div>{{ form.date_type === 1 ? $t('15475_589e04e2') : $t('15475_89e04e26') }}</div>
      </el-form-item>
      <el-form-item :label="$t('79')">
        <el-select v-model="form.state" :placeholder="$t('79')" clearable multiple>
          <el-option v-for="item in stateArr" :key="item.code" :label="item.value" :value="item.code"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('30751110')">
        <depart :change="selectDepart" :mprop="{ checkStrictly: true }" multiple />
      </el-form-item>
    </el-form>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="doSubmit" :disabled="!isExport" :loading="exportLoading">{{
        $t('07511100')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import datePicker from '_c/date-picker'
import depart from '@/components/department'
import { exportMore, getBuildInTypes, configFn } from 'api/approval/search'
const form = () => ({
  state: '',
  audit_type: '',
  create_date_start: '',
  create_date_end: '',
  submitter_department_id: '',
  finish_date_start: '',
  finish_date_end: '',
  date_type: 1
})
export default {
  components: {
    datePicker,
    depart
  },
  props: {
    stateArr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      exportLoading: false,
      form: form(),
      typeArr: [],
      upDate: true,
      isMultiple: '',
      createDate: [],
      finishDate: []
    }
  },
  computed: {
    isExport: vm =>
      (vm.form.create_date_end && vm.form.create_date_start) ||
      (vm.form.finish_date_start && vm.form.finish_date_end && vm.form.audit_type)
  },
  watch: {
    // 解决切换时间类型时报错
    isMultiple() {
      this.upDate = false
      setTimeout(() => {
        this.upDate = true
      })
    }
  },
  methods: {
    init() {
      this.visible = true
      this.form = form()
      this.changeType()
    },
    // 部门级连选择
    selectDepart(_, current) {
      this.form.submitter_department_id = current.map(item => item.slice(-1)[0])
    },
    // 导出查询结果
    doSubmit() {
      this.exportLoading = true
      exportMore(this.form)
        .then(res => {
          this.$message.success(res.message)
          this.visible = false
        })
        .finally(() => (this.exportLoading = false))
    },
    async changeType(val) {
      ;[this.form.create_date_start, this.form.create_date_end] = ['', '']
      ;[this.form.finish_date_start, this.form.finish_date_end] = ['', '']
      this.form.submitter_department_id = ''
      this.form.audit_type = ''
      this.finishDate = []
      this.createDate = []
      if (val === 2) {
        const res = await getBuildInTypes()
        this.typeArr = res.data.map(v => ({
          label: v.value,
          value: v.code
        }))
        this.isMultiple = false
        return
      }
      const res = await configFn()
      if (res && res.code === 1) {
        this.typeArr = res.data.audit_type.map(v => ({
          label: v.value,
          value: v.code
        }))
      }
      this.isMultiple = true
    }
  }
}
</script>
